import React, { Component } from 'react';
import PropTypes from 'prop-types';
// ---
import ReactSlick from 'react-slick';
// import ReactSlick from './react-slick';
// ---
import { withRadium, DetectCompact } from '../../higher-order-components'
// ---
import { convertPipeToBrTag, eventWithPoint, Vectors } from '../../utils';
// ---
import Wrapper from '../../components/wrapper';
import './styles.css';
import Promo from "../promo";
import PromoAndButtonModalWindow from "../promo-and-button-modal-window";
import Video from "../video";
import Html from "../html";
import Wysiwyg from "../wysiwyg";
import Cta from '../cta';

// --------------------------------------------------
export const FeatureCategorySlider = ({ settings, children }) => (
  <ReactSlick {...settings}>
    {children}
  </ReactSlick>
);

FeatureCategorySlider.propTypes = {
  settings: PropTypes.shape().isRequired,
  children: PropTypes.array.isRequired,
};

withRadium(DetectCompact())(FeatureCategorySlider);

// --------------------------------------------------
/**
 * slick 使用しない component
 * @param {*} props Resct.props
 * @returns {any[]} `ReactElement` - {@link Promo} /  {@link Video} /  {@link Html} /  {@link Wysiwyg}
 * @constructor
 */
const FeatureCategoryContainerItemWrap = props => (
  props.components.map((component, index) => {
      const componentProps = Object.assign({}, component.props);
      // console.log('FeatureCategoryContainerItemWrap', index, component.name, props);
      // getRef だと height 取れないので `ref` に変えて取得する
      switch(component.name) {
        case 'Promo': {
          return <Promo
            uniqueId={`promo-${props.mode}-${props.filterId}-${index}`}
            {...componentProps}
            ref={element => (Array.isArray(props.childRefs) ? props.childRefs.push(element) : null)}
          />;
        }
        case 'PromoAndButtonModalWindow': {
          return <PromoAndButtonModalWindow
            uniqueId={`promo-${props.mode}-${props.filterId}-${index}`}
            {...componentProps}
            ref={element => (Array.isArray(props.childRefs) ? props.childRefs.push(element) : null)}
            parentColumn='featureCategoryContainer'
          />;
        }
        case 'Video': {
          return <Video
            uniqueId={`promo-${props.mode}-${props.filterId}-${index}`}
            {...componentProps}
            ref={element => (Array.isArray(props.childRefs) ? props.childRefs.push(element) : null)}
          />;
        }
        case 'Html': {
          return <Html
            uniqueId={`promo-${props.mode}-${props.filterId}-${index}`}
            {...componentProps}
            ref={element => (Array.isArray(props.childRefs) ? props.childRefs.push(element) : null)}
          />;
        }
        case 'Wysiwyg': {
          return <Wysiwyg
            uniqueId={`promo-${props.mode}-${props.filterId}-${index}`}
            {...componentProps}
            ref={element => (Array.isArray(props.childRefs) ? props.childRefs.push(element) : null)}
          />;
        }
        default: {
          return null;
        }
      }
    })
    .filter(component => (component !== null))
    .map(component => (
      <div key={component.props.uniqueId} className="FeatureCategoryContainer__content__item">
        {component}
      </div>
    ))
);

FeatureCategoryContainerItemWrap.propTypes = {
  filterId: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  components: PropTypes.array.isRequired,
};
// --------------------------------------------------
// `div.FeatureCategoryContainer__content__item` 毎 component にしないと react-slick がそれぞれ子供と認識してしまう

// getRef だと height 取れないので `ref` に変えて取得する
const ItemPromo = props => (
  <div
    // key={`item-${props.uniqueId}`}
    className="FeatureCategoryContainer__content__item"
  >
    <Promo
      {...props}
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref={component => (props.childRefs.push(component))}
    />
  </div>
);

const ItemPromoAndButtonModalWindow = props => (
  <div
    // key={`item-${props.uniqueId}`}
    className="FeatureCategoryContainer__content__item"
  >
    <PromoAndButtonModalWindow
      {...props}
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref={component => (props.childRefs.push(component))}
      parentColumn='featureCategoryContainer'
    />
  </div>
);

const ItemVideo = props => (
  <div
    // key={`item-${props.uniqueId}`}
    className="FeatureCategoryContainer__content__item"
  >
    <Video
      {...props}
      // ref={component => (Array.isArray(props.childRefs) ? props.childRefs.push(component) : null)}
      ref={component => (props.childRefs.push(component))}
    />
  </div>
);

const ItemHtml = props => (
  <div
    // key={`item-${props.uniqueId}`}
    className="FeatureCategoryContainer__content__item"
  >
    {/*{*/}
      {/*props.childRefs.push(null)*/}
    {/*}*/}
    <Html
      {...props}
      ref={component => (props.childRefs.push(component))}
    />
  </div>
);

const ItemWysiwyg = props => (
  <div
    // key={`item-${props.uniqueId}`}
    className="FeatureCategoryContainer__content__item"
  >
    {/*{*/}
      {/*props.childRefs.push(null)*/}
    {/*}*/}
    <Wysiwyg
      {...props}
      ref={component => (props.childRefs.push(component))}
    />
  </div>
);
// // --------------------------------------------------
// /**
//  * filter title component
//  * @param {string} title title `|` `<br`> 変換
//  * @param {string} filterId title filter Id
//  * @param {boolean} hasSecond 第二階層存在 flag
//  * @param {string} titleClickCaller click callback receiver
//  * @param {boolean} sameFilterId selected flag
//  * @returns {React.Element} `div.FeatureCategoryContainer__title`
//  * @constructor
//  */
// const FeatureCategoryContainerTitle = ({ title, filterId, hasSecond, titleClickCaller, sameFilterId }) => {
//   if (!title) {
//     return null;
//   }
//   // ---
//   const selectedClass = sameFilterId ? 'FeatureCategoryContainer__title__selected': '';
//   const hasSecondClass = hasSecond ? 'FeatureCategoryContainer__title__has_child': '';
//   // console.log('FeatureCategoryContainerTitle', title, filterId, currentFilterId, selectedClass, sameFilterId);
//   return (
//     <div
//       className={`FeatureCategoryContainer__title ${selectedClass} ${hasSecondClass}`}
//       data-id={filterId}
//       role="presentation"
//       dangerouslySetInnerHTML={{__html: convertPipeToBrTag(title)}}
//       onClick={(event) => {
//         event.preventDefault();
//         if (typeof titleClickCaller === 'function') {
//           titleClickCaller.call(this, filterId, title);
//         }
//       }}
//     />
//   );
// };
//
// FeatureCategoryContainerTitle.propTypes = {
//   title: PropTypes.string,
//   titleClickCaller: PropTypes.func,
//   filterId: PropTypes.string.isRequired,
//   hasSecond: PropTypes.bool.isRequired,
//   sameFilterId: PropTypes.bool.isRequired,
// };
//
// FeatureCategoryContainerTitle.defaultProps = {
//   title: null,
//   titleClickCaller: null,
// };

class FeatureCategoryContainerTitle extends Component {
  static propTypes = {
    title: PropTypes.string,
    titleClickCaller: PropTypes.func,
    filterId: PropTypes.string.isRequired,
    hasSecond: PropTypes.bool.isRequired,
    sameFilterId: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    title: null,
    titleClickCaller: null,
  };
  constructor(props) {
    super(props);
    this.refContainer = null;
  }
  getTitleClientRect() {
    return this.refContainer ? this.refContainer.getBoundingClientRect() : null;
  }
  render() {
    const { title, filterId, hasSecond, titleClickCaller, sameFilterId } = this.props;
    if (!title) {
      return null;
    }
    // ---
    const selectedClass = sameFilterId ? 'FeatureCategoryContainer__title__selected' : '';
    const hasSecondClass = hasSecond ? 'FeatureCategoryContainer__title__has_child' : '';
    // console.log('FeatureCategoryContainerTitle', title, filterId, sameFilterId, selectedClass, hasSecond, hasSecondClass);
    return (
      <div
        className={`FeatureCategoryContainer__title ${selectedClass} ${hasSecondClass}`}
        data-id={filterId}
        role="presentation"
        dangerouslySetInnerHTML={{__html: convertPipeToBrTag(title)}}
        onClick={(event) => {
          event.preventDefault();
          if (typeof titleClickCaller === 'function') {
            titleClickCaller.call(this, filterId, title);
          }
        }}
        ref={component => (this.refContainer = component)}
      />
    );
  }
}

// --------------------------------------------------
const getComponentsHeight = (components) => (
  components
    // .filter(component => (component && component.getContentsHeight))
    .map(component => {
      if (component && component.getContentsHeight) {
        return component.getContentsHeight();
      }
      return 0;
    })
);

// --------------------------------------------------
const FeatureCategoryContainerItemSelect = ({ component, index, mode, childRefs, filterId }) => {
  const props = Object.assign({}, component.props);
  switch(component.name) {
    case 'Promo': {
      return (
        <ItemPromo
          key={`promo-${mode}-${filterId}-${index}`}
          {...props}
          uniqueId={`promo-${mode}-${filterId}-${index}`}
          childRefs={childRefs}
        />
      );
    }
    case 'PromoAndButtonModalWindow': {
      return (
        <ItemPromoAndButtonModalWindow
          key={`promo-${mode}-${filterId}-${index}`}
          {...props}
          uniqueId={`promo-${mode}-${filterId}-${index}`}
          childRefs={childRefs}
          parentColumn='featureCategoryContainer'
        />
      );
    }
    case 'Video': {
      return (
        <ItemVideo
          key={`promo-${mode}-${filterId}-${index}`}
          {...props}
          uniqueId={`promo-${mode}-${filterId}-${index}`}
          childRefs={childRefs}
        />
      );
    }
    case 'Html': {
      return (
        <ItemHtml
          key={`promo-${mode}-${filterId}-${index}`}
          {...props}
          uniqueId={`promo-${mode}-${filterId}-${index}`}
          childRefs={childRefs}
        />
      );
    }
    case 'Wysiwyg': {
      return (
        <ItemWysiwyg
          key={`promo-${mode}-${filterId}-${index}`}
          {...props}
          uniqueId={`promo-${mode}-${filterId}-${index}`}
          childRefs={childRefs}
        />
      );
    }
    default: {
      return null;
    }
  }
};
// --------------------------------------------------
/**
 * desktop size - layout `Vertical`
 */
class FeatureCategoryContainerVerticalPc extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    title: PropTypes.string,
    components: PropTypes.array,
    // ---
    // extend
    showTitle: PropTypes.bool,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    layout: PropTypes.string,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
    titleClickCaller: PropTypes.func,
    // ---
    readMoreLabel: PropTypes.string,
    selectTextColor: PropTypes.string,
    currentContainerIndex: PropTypes.number,
    opacityZeroClassName: PropTypes.string,
    abortTransitionClassName: PropTypes.string,
    slickThumbnailChangedCallback: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    title: null,
    components: [],
    // ---
    // extend
    showTitle: false,
    currentFilterId: '',
    filterId: '',
    titleClickCaller: null,
    // ---
    layout: 'Horizontal',
    pcDisplayLine: 4,
    mbDisplayLine: 4,
    // ---
    readMoreLabel: '',
    selectTextColor: '',
    currentContainerIndex: 0,
    opacityZeroClassName: '',
    abortTransitionClassName: '',
    slickThumbnailChangedCallback: null,
  };

  // --------------------------------------------------
  constructor(props) {
    super(props);
    // ---
    this.state = {
      more: true,
      read: -1,
    };
    this.didMount = false;
    this.onClickMore = this.onClickMore.bind(this);
    // ---
    /**
     * contents per line
     * @type {number}
     */
    this.each = 4;
    /**
     * 各 filter id 毎の current page number を保存します
     * @type {{}}
     */
    this.pages = {};
    // ---
    this.components = [];
    /**
     * last components inderx
     * @type {number}
     */
    this.last = 0;
    /**
     * current line number
     * @type {number}
     */
    this.page = 0;
    /**
     * last line number - limit page number
     * @type {number}
     */
    this.lastPage = 0;
    /**
     * display line
     * @type {number}
     */
    this.line = 0;
    /**
     * components length
     * @type {number}
     */
    this.length = 0;
    /**
     * pc / mb flag - true: PC
     * @type {boolean}
     */
    this.pc = true;
    this.initComponents(props.pcDisplayLine);
    this.containerComponents = {};
    this.onResize = this.onResize.bind(this);
    this.timer = {
      fitHeight: 0,
      didUpdate: 0,
    };
    this.opacityZeroClassName = props.opacityZeroClassName;
    this.isIE = props.isIE;
    this.displayLine = props.pcDisplayLine;
    this.intervalId = null;
  }
  // --------------------------------------------------
  onResize() {
    this.delayGetAndSetMaxHeight();
  }
  // --------------------------------------------------
  onClickMore(event) {
    event.preventDefault();
    this.next();
  }

  // --------------------------------------------------
  next() {
    const needMore = this.checkNeedMore();
    // console.log('FeatureCategoryContainerVerticalPc.next', needMore);
    if (needMore) {
      // ---
      this.page += 1;
      this.pages[this.props.filterId] = this.page;
      this.setState({read: this.page, more: needMore});
    }
  }

  // --------------------------------------------------
  initComponents(line) {
    const {
      filterId,
    } = this.props;
    // ---
    if (typeof this.pages[filterId] === 'undefined') {
      this.pages[filterId] = 1;
      this.page = 1;
    } else {
      this.page = this.pages[filterId];
    }
    // ---
    const components = this.filterComponents();
    const length = components.length;
    this.components = components;
    this.last = length - 1;
    this.length = length;
    this.line = line;
    this.lastPage = Math.ceil(length / (this.each * line));
  }

  filterComponents() {
    const {components} = this.props;
    return components.filter(component => (
      component.name === 'Promo' ||
      component.name === 'PromoAndButtonModalWindow' ||
      component.name === 'Video' ||
      component.name === 'Html' ||
      component.name === 'Wysiwyg'
    ))
  }

  // --------------------------------------------------
  checkNeedMore() {
    return this.page < this.lastPage;
  }

  shouldUpdateMore() {
    let state = null;
    const need = this.checkNeedMore();
    if (this.state.more !== need) {
      state = {
        more: need,
      };
    }
    if (state) {
      this.setState(state);
    }
  }

  limitByPage(page) {
    // current page - has more
    // console.log('FeatureCategoryContainerVerticalPc.limitByPage', this.pc, page, this.line, this.each, this.last);
    // return Math.min(page * this.line * this.each, this.length);
    return this.length;
  }

  nextLimit(page) {
    return this.limitByPage(page);
  }

  resetView() {
    // console.log('FeatureCategoryContainerVerticalPc.resetView', this.props);
    const { pcDisplayLine, mbDisplayLine } = this.props;
    const line = this.pc ? pcDisplayLine: mbDisplayLine;
    this.initComponents(line);
    this.setState({ read: this.page, more: this.checkNeedMore() });
  }
  // --------------------------------------------------
  /**
   * 子供の高さを揃えるために高さを取得し max height を設定する
   * @param {array[*]} list component list - 行ごと
   */
  getAndSetMaxHeight(list) {
    const results = getComponentsHeight(list);
    results.sort((a, b) => (b - a));
    const maxHeight = results[0];
    list
      .filter(component => (component && component.setContainerHeight))
      .map(component => (component.setContainerHeight(maxHeight)))
  }
  /**
   * 行ごと（1行表示個数毎）に component list を分割します
   */
  splitEachLine() {
    const { filterId, components } = this.props;
    const containerItems = this.containerComponents[filterId].pc;
    const last = containerItems.length - 1;
    const eachTime = this.each;
    let divide = -1;
    // @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    return containerItems.reduce((result, value, index, array) => {
      if ((index + 1) % eachTime === 0) {
        const sliced = array.slice(divide + 1, divide + 1 + eachTime);
        result.push(sliced);
        // console.log('FeatureCategoryContainerVerticalPc.splitEachLine - slice', divide + 1, divide + 1 + eachTime, sliced);
        divide = index;
      } else if (index === last) {
        const sliced = array.slice(divide + 1, index + eachTime);
        result.push(sliced);
        // console.log('FeatureCategoryContainerVerticalPc.splitEachLine - slice last', divide + 1, index, last, sliced);
      }
      return result;
    }, []);
  }
  delayGetAndSetMaxHeight(delay = 112 * 2) {
    const k = 1;
    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(() => {
      const lines = this.splitEachLine().slice(0);
      lines.length = (this.page * this.displayLine);
      // console.log('FeatureCategoryContainerVerticalPc.delayGetAndSetMaxHeight', lines, this.page);
      lines.map(list => (this.getAndSetMaxHeight(list)));
    }, delay * k);
  }
  // --------------------------------------------------
  splitByDisplayLine(containerItems) {
    const { filterId, pcDisplayLine, mbDisplayLine } = this.props;
    const line = this.pc ? pcDisplayLine : mbDisplayLine;
    const eachTime = this.each * line;
    // @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    return containerItems.reduce((result, value, index, array) => {
      if (index % eachTime === 0) {
        result.push(array.slice(index, index + eachTime));
      }
      return result;
    }, [])
  }
  // --------------------------------------------------
  abortOpacityZero() {
    // const { abortOpacityZero } = this.props;
    // if (typeof abortOpacityZero === 'function') {
    //   abortOpacityZero.call(this);
    // }
  }
  delayAbortOpacityZero(delay = 320) {
    this.timer.opacityZero = setTimeout(() => {
      this.abortOpacityZero();
    }, delay);
  }
  // --------------------------------------------------
  componentDidUpdate(prevProps) {
    // console.log('FeatureCategoryContainerVerticalPc.componentDidUpdate', this.props.filterId, this.props.currentFilterId, prevProps.currentFilterId, prevProps.currentFilterId !== this.props.currentFilterId);
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      this.resetView();
      // if (this.props.currentFilterId === this.props.filterId) {
      //   // this.delayAbortOpacityZero(1000);
      //   this.delayAbortOpacityZero(500);
      // }
    } else {
      this.shouldUpdateMore();
      if (this.pc) {
        this.delayGetAndSetMaxHeight();
      }
    }
  }

  componentDidMount() {
    this.didMount = true;
    this.shouldUpdateMore();
    if (this.pc) {
      this.delayGetAndSetMaxHeight();

      // window.addEventListener('resize', this.onResize, false);
      setTimeout(()=> {
        window.addEventListener('resize', this.onResize, false);
      }, 500);
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(()=> {
        this.onResize();
      }, 1000);


      // this.delayAbortOpacityZero(1500);
      // this.delayAbortOpacityZero(16);
    }
  }

  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
    Object.values(this.timer).map(id => (clearTimeout(id)));
    window.removeEventListener('resize', this.onResize);
  }
  // --------------------------------------------------
  /**
   * FeatureCategoryContainer.props.components を出力します
   * @param {number} limit length - 使用しない - コード互換のために残す
   * @returns {ReactElement} FeatureCategoryContainer.props.components
   */
  renderItemsAllWithSegment(limit) {
    const { filterId } = this.props;
    const mode = this.pc ? 'pc-vertical' : 'mb-vertical';
    const components = this.components;
    const componentsClone = components.slice(0);
    // crop output components array
    componentsClone.length = limit;
    const outputComponents = this.splitByDisplayLine(componentsClone);
    // ---
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: [],
      };
    }
    // ---
    if (this.pc) {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    const childRefs = this.pc ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // console.log('FeatureCategoryContainer.renderItemsAllWithSegment', this.pc, filterId, this.page, limit, childRefs);

    return (
      outputComponents.map((list, i) => {
        if (i <= (this.page - 1)) {
          return (
            <div
              key={`${filterId}-${i}`}
              className={`FeatureCategoryContainer__content__item__wrap ${i <= (this.page - 1) ? 'FeatureCategoryContainer__content__item__wrap__current' : ''}`}
              data-segment={`${i}`}
            >
              {
                list.map((component, index) => (
                  <FeatureCategoryContainerItemSelect
                    key={`${component.name}-${mode}-${filterId}-${index}`}
                    component={component}
                    index={index}
                    mode={mode}
                    childRefs={childRefs}
                    filterId={filterId}
                  />
                ))
              }
            </div>
          )
        } else {
          return (
            <div
              key={`${filterId}-${i}`}
              className={`FeatureCategoryContainer__content__item__wrap`}
              data-segment={`${i}`}
            >
            </div>
          )
        }
      }
    ))

    /*
    return (
      outputComponents.map((list, i) => (
        <div
          key={`${filterId}-${i}`}
          className={`FeatureCategoryContainer__content__item__wrap ${i <= (this.page - 1) ? 'FeatureCategoryContainer__content__item__wrap__current' : ''}`}
          data-segment={`${i}`}
        >
          {
            list.map((component, index) => (
              <FeatureCategoryContainerItemSelect
                key={`${component.name}-${mode}-${filterId}-${index}`}
                component={component}
                index={index}
                mode={mode}
                childRefs={childRefs}
                filterId={filterId}
              />
            ))
          }
        </div>
      ))
    );
    */

  }

  /**
   * @deprecated instead use {@link FeatureCategoryContainer.renderItemsAllWithSegment}
   * FeatureCategoryContainer.props.components を出力します
   * @param {string} mode class に付与する識別子
   * @param {number} limit length
   * @returns {ReactElement} FeatureCategoryContainer.props.components
   */
  renderItemWrap(mode, limit) {
    const { filterId } = this.props;
    const components = this.components;
    const componentsClone = components.slice(0);
    // crop output components array
    componentsClone.length = limit;
    // ---
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: [],
      };
    }
    // ---
    if (this.pc) {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    const childRefs = this.pc ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // return (
    //   componentsClone.map((component, index) => {
    //       const props = Object.assign({}, component.props);
    //       // console.log('FeatureCategoryContainerItemWrap', index, component.name);
    //       switch(component.name) {
    //         case 'Promo': {
    //           return (
    //             <ItemPromo
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //               childRefs={childRefs}
    //             />
    //           );
    //         }
    //         case 'Video': {
    //           return (
    //             <ItemVideo
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //               childRefs={childRefs}
    //             />
    //           );
    //         }
    //         case 'Html': {
    //           return (
    //             <ItemHtml
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //             />
    //           );
    //         }
    //         case 'Wysiwyg': {
    //           return (
    //             <ItemWysiwyg
    //               key={`promo-${mode}-${filterId}-${index}`}
    //               {...props}
    //               uniqueId={`promo-${mode}-${filterId}-${index}`}
    //             />
    //           );
    //         }
    //         default: {
    //           return null;
    //         }
    //       }
    //     })
    //     .filter(component => (component !== null))
    // );
    return (
      componentsClone.map((component, index) => (
        <FeatureCategoryContainerItemSelect
          key={`${component.name}-${mode}-${filterId}-${index}`}
          component={component}
          index={index}
          mode={mode}
          childRefs={childRefs}
          filterId={filterId}
        />
      ))
    );
  }

  // --------------------------------------------------
  renderMore() {
    const { more } = this.state;
    if (!more) {
      return null;
    }
    const { readMoreLabel, selectTextColor } = this.props;
    // return (
    //   <button
    //     className={`FeatureCategoryContainer__content__btn__more-${this.pc ? 'pc' : 'mb'}`}
    //     type="button"
    //     onClick={this.onClickMore}
    //   >
    //     {readMoreLabel}
    //   </button>
    // );
    return (
      <div
        className={`FeatureCategoryContainer__content__btn__more-${this.pc ? 'pc' : 'mb'}`}
      >
        <Cta
          ctaType="Free"
          text={readMoreLabel}
          linkType="Button"
          color={selectTextColor}
          buttonStyle="Standard"
          handleClick={this.onClickMore}
        />
      </div>
    );
  }

  renderItem() {
    const limit = this.nextLimit(this.page);
    // console.log('FeatureCategoryContainerVerticalPc.renderItem', limit, this.state);
    // ---
    // return (
    //   <div className="FeatureCategoryContainer__content__item__wrap">
    //     {
    //       // this.renderItemWrap('pc-vertical', limit)
    //       this.renderItemsAllWithSegment('pc-vertical', limit)
    //     }
    //   </div>
    // );
    return this.renderItemsAllWithSegment(limit);
  }

  // --------------------------------------------------
  render() {
    const {
      layout,
    } = this.props;
    // ---
    if (layout !== 'Vertical') {
      return null;
    }
    // ---
    const components = this.components;
    if (!components.length) {
      return null;
    }
    return (
      <div className={`FeatureCategoryContainer__content-${this.pc ? 'pc' : 'mb'}`}>
        {this.renderItem()}
        {this.renderMore()}
      </div>
    );
  }
}

// --------------------------------------------------
/**
 * mobile - layout `Vertical`
 */
class FeatureCategoryContainerVerticalMb extends FeatureCategoryContainerVerticalPc {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    title: PropTypes.string,
    components: PropTypes.array,
    // ---
    // extend
    showTitle: PropTypes.bool,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    layout: PropTypes.string,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
    titleClickCaller: PropTypes.func,
    // ---
    readMoreLabel: PropTypes.string,
    selectTextColor: PropTypes.string,
    currentContainerIndex: PropTypes.number,
    opacityZeroClassName: PropTypes.string,
    abortTransitionClassName: PropTypes.string,
    slickThumbnailChangedCallback: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    title: null,
    components: [],
    // ---
    // extend
    showTitle: false,
    currentFilterId: '',
    filterId: '',
    titleClickCaller: null,
    // ---
    layout: 'Horizontal',
    pcDisplayLine: 4,
    mbDisplayLine: 4,
    // ---
    readMoreLabel: '',
    selectTextColor: '',
    currentContainerIndex: 0,
    opacityZeroClassName: '',
    abortTransitionClassName: '',
    slickThumbnailChangedCallback: null,
  };

  constructor(props) {
    super(props);
    // ---
    this.each = 1;
    this.pages = {};
    // console.log('FeatureCategoryContainerVerticalMb', props.mbDisplayLine);
    this.pc = false;
    this.initComponents(props.mbDisplayLine);
    this.onClickMore = this.onClickMore.bind(this);
    this.displayLine = props.mbDisplayLine;
  }

  // --------------------------------------------------
  // renderMore() {
  //   const {more} = this.state;
  //   if (!more) {
  //     return null;
  //   }
  //   const {readMoreLabel} = this.props;
  //   return (
  //     <button
  //       className="FeatureCategoryContainer__content__btn__more-mb"
  //       type="button"
  //       onClick={this.onClickMore}
  //     >
  //       {readMoreLabel}
  //       </button>
  //   );
  // }
  // renderItem() {
  //   const limit = this.nextLimit(this.page);
  //   return this.renderItemsAllWithSegment('mb-vertical', limit);
  // }
  // --------------------------------------------------
  // render() {
  //   const {
  //     layout,
  //   } = this.props;
  //   // ---
  //   if (layout !== 'Vertical') {
  //     return null;
  //   }
  //   // ---
  //   const components = this.components;
  //   if (!components.length) {
  //     return null;
  //   }
  //   return (
  //     <div className="FeatureCategoryContainer__content-mb">
  //       {this.renderItem()}
  //       {this.renderMore()}
  //     </div>
  //   );
  // }
}

// --------------------------------------------------
/**
 * Horizontal - slick or not slick (desktop / mobile)
 */
export class FeatureCategoryContainerHorizontal extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    title: PropTypes.string,
    components: PropTypes.array,
    // ---
    // extend
    showTitle: PropTypes.bool,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    layout: PropTypes.string,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
    titleClickCaller: PropTypes.func,
    // ---
    readMoreLabel: PropTypes.string,
    currentContainerIndex: PropTypes.number,
    opacityZeroClassName: PropTypes.string,
    abortTransitionClassName: PropTypes.string,
    filterChangeOpacityClassName: PropTypes.string,
    abortOpacityZero: PropTypes.func,
    changedFilter: PropTypes.bool,
    slickThumbnailChangedCallback: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    title: null,
    components: [],
    // ---
    // extend
    showTitle: false,
    currentFilterId: '',
    filterId: '',
    titleClickCaller: null,
    // ---
    layout: 'Horizontal',
    pcDisplayLine: 4,
    mbDisplayLine: 4,
    // ---
    readMoreLabel: '',
    currentContainerIndex: 0,
    opacityZeroClassName: '',
    abortTransitionClassName: '',
    filterChangeOpacityClassName: '',
    abortOpacityZero: null,
    changedFilter: false,
    slickThumbnailChangedCallback: null,
  };
  constructor(props) {
    super(props);
    // ---
    const pcEachTime = 4;
    const mbEachTime = 1;
    this.components = props.components;
    const componentsLength = this.components.length;
    this.slider = {
      pc: null,
      mb: null,
      page: {
        index: {
          pc: 0,
          mb: 0,
        },
        last: {
          pc: 0,
          mb: 0,
        },
      },
      eachTime: {
        pc: pcEachTime,
        mb: mbEachTime,
      },
      length: componentsLength,
      // length: 0,
      index: {
        pc: 0,
        mb: 0,
      },
    };
    this.transitionClasses = {
      click: 'FeatureCategoryContainer__content__btn__clicked',
      blink: 'FeatureCategoryContainer__content__btn__blink',
      slickTrackTransition: 'FeatureCategoryContainer__no__slick__transition',
    };
    this.state = {
      pcIndex: 0,
      mbIndex: 0,
      length: componentsLength,
      didMount: false,
      didMpUpdate: false,
      resizeByMaxHeight: false,
      heightFromMaxHeight: 0,
      arrowPrevClass: '',
      arrowNextClass: '',
      slickTrackTransition: this.transitionClasses.slickTrackTransition,
    };
    // ---
    /**
     * mb - thumbnail swipe 計算に使用します
     * @type {{start: Vectors, end: Vectors}}
     */
    this.vectors = {
      start: new Vectors(),
      end: new Vectors(),
    };
    /**
     * swipe 閾値
     * @type {number}
     * @default 5
     */
    this.swipeThreshold = 5;
    this.onPcPrev = this.onPcPrev.bind(this);
    this.onPcNext = this.onPcNext.bind(this);
    this.onClickPager = this.onClickPager.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTouchCancel = this.onTouchCancel.bind(this);
    this.onMbPrev = this.onMbPrev.bind(this);
    this.onMbNext = this.onMbNext.bind(this);
    /**
     * slick transition `none` class name
     * - filter 切替時の slick 初期化時に ON します
     * @type {string}
     */
    this.trackIgnore = props.abortTransitionClassName;
    /**
     * timer id list
     * @type {{fitHeight: number, thumbnailPc: number, thumbnailMb: number}}
     */
    this.timer = {
      fitHeight: 0,
      thumbnailPc: 0,
      thumbnailMb: 0,
      didMount: 0,
      resetSlider: 0,
      didUpdate: 0,
      arrow: 0,
      opacityZero: 0,
      slickTrackDuration: 0,
    };
    this.containerComponents = {};
    this.onResize = this.onResize.bind(this);
    // ---
    this.onPcThumbnailBeforeChange = this.onPcThumbnailBeforeChange.bind(this);
    this.onPcThumbnailAfterChange = this.onPcThumbnailAfterChange.bind(this);
    this.onMbThumbnailBeforeChange = this.onMbThumbnailBeforeChange.bind(this);
    this.onMbThumbnailAfterChange = this.onMbThumbnailAfterChange.bind(this);
    this.slickIndex = {
      pc: 0,
      mb: 0,
    };
    this.syncCount = {
      pc: 0,
      mb: 0,
    };
    // ---
    this.contents = {
      pc: null,
      mb: null,
    };
    // ---
    this.currentFilterId = props.currentFilterId;
    // ---
    this.opacityZeroClassName = props.opacityZeroClassName;
    // ---
    this.initSliderProps();
    this.intervalId = null;
  }
  // --------------------------------------------------
  initSliderProps() {
    // console.log('FeatureCategoryContainer.initSliderProps', this.props.filterId, this.props.currentFilterId);
    const { components } = this.props;
    this.components = components;
    const componentsLength = this.components.length;
    const pcEachTime = this.slider.eachTime.pc;
    const mbEachTime = this.slider.eachTime.mb;
    this.slider.page.index = {
      pc: 0,
      mb: 0,
    };
    this.slider.index = {
      pc: 0,
      mb: 0,
    };
    this.slider.page.last = {
      pc: Math.ceil(componentsLength / pcEachTime) - 1,
      mb: Math.ceil(componentsLength / mbEachTime) - 1,
    };
    this.slider.length = componentsLength;
  }
  // --------------------------------------------------
  onResize() {
    this.delayGetAndSetMaxHeight();
  }
  // --------------------------------------------------
  onPcThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.pc = nextSlideIndex;
  }

  onPcThumbnailAfterChange(currentSlideIndex) {
    this.slickIndex.pc = currentSlideIndex;
    // const { slickThumbnailChangedCallback } = this.props;
    // if (typeof slickThumbnailChangedCallback === 'function') {
    //   slickThumbnailChangedCallback.call(this);
    // }
    this.slickAfterChange();
  }

  onMbThumbnailBeforeChange(currentSlideIndex, nextSlideIndex) {
    this.slickIndex.mb = nextSlideIndex;
  }

  onMbThumbnailAfterChange(currentSlideIndex) {
    this.slickIndex.mb = currentSlideIndex;
    // const {slickThumbnailChangedCallback} = this.props;
    // if (typeof slickThumbnailChangedCallback === 'function') {
    //   slickThumbnailChangedCallback.call(this);
    // }
    this.slickAfterChange();
  }

  /**
   * slick after change で callback 起動する
   */
  slickAfterChange() {
    // console.log('FeatureCategoriesContainer.slickAfterChange', this.props.filterId, this.slickIndex);
    if (this.props.currentFilterId === this.props.filterId) {
      this.abortOpacityZero();
    }
    this.abortSlickTransitionZero();
  }
  // --------------------------------------------------
  onClickPager(event) {
    // console.log('FeatureCategoriesContainer.onClickPager - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    event.preventDefault();
    const target = event.target.nodeName.toLowerCase() === 'span' ? event.target.parentNode: event.target;
    const pcIndex = parseInt(target.dataset.page, 10);
    if (this.state.pcIndex !== pcIndex) {
      this.setState({ pcIndex });
      this.slider.page.index.pc = pcIndex;
      const pcExpectIndex = pcIndex * this.slider.eachTime.pc;
      if (pcIndex !== this.slider.page.last.pc) {
        this.pcGoto(pcExpectIndex);
      } else {
        this.pcLastWithDead(pcIndex);
      }
    }
  }

  onPcPrev(event) {
    event.preventDefault();
    // prev / next click - arrow animation を止める
    if (this.state.arrowPrevClass || this.state.arrowNextClass) {
      this.delayClearArrowClass(0);
    }
    // this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    // console.log('FeatureCategoriesContainer.onPcPrev - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    // this.pcPrev();
    setTimeout(() => {
      this.pcPrev();
    }, 1);
  }

  onPcNext(event) {
    event.preventDefault();
    // prev / next click - arrow animation を止める
    if (this.state.arrowPrevClass || this.state.arrowNextClass) {
      this.delayClearArrowClass(0);
    }
    // this.setState({ arrowPrevClass: '', arrowNextClass: '' });
    // console.log('FeatureCategoriesContainer.onPcNext - clearTimerResetSlider');
    this.clearTimerResetSlider();
    // ---
    setTimeout(() => {
      this.pcNext();
    }, 1);
  }
  pcPrev(noMbMove = false) {
    const { pc } = this.slider;
    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.click, arrowNextClass: this.transitionClasses.blink });
      this.delayClearArrowClass();
      // pc.slickPrev();
      const page = this.slider.page.index.pc - 1;
      // console.log('FeatureCategoryContainerHorizontal.pcPrev', page, this.slider.page.last.pc);
      if (page < 0) {
        this.pcFirstToLast(noMbMove);
        return;
      } else if (page === 0) {
        this.pcFirstWithDead(page, noMbMove);
        return;
      }
      // normal
      this.slider.page.index.pc = page;
      const pcEachTime = this.slider.eachTime.pc;
      const pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  }

  /**
   * PC - slick prev, page: 0 移動
   * @param {number} page page number
   * @param {boolean} noMbMove - mb move flag
   */
  pcFirstWithDead(page, noMbMove) {
    const { pc } = this.slider;
    if (pc) {
      this.slider.page.index.pc = page;
      const pcEachTime = this.slider.eachTime.pc;
      const pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  }
  /**
   * PC - slick prev, page last to first move
   * @param {boolean} noMbMove - mb move flag
   */
  pcFirstToLast(noMbMove) {
    const { pc } = this.slider;
    if (pc) {
      const pcLast = this.slider.page.last.pc;
      this.slider.page.index.pc = pcLast;
      const pcEachTime = this.slider.eachTime.pc;
      const pcExpectIndex = -pcEachTime;
      // console.log('FeatureCategoryContainerHorizontal.pcFirstToLast', pcExpectIndex, pcLast, rest, length, pcLast * pcEachTime);
      pc.slickGoTo(pcExpectIndex);
      if (!noMbMove) {
        this.mbMoveByPc(pcLast * pcEachTime);
      }
      this.pcChangeState(pcLast);
    }
  }

  pcNext(noMbMove = false) {
    const { pc } = this.slider;
    if (pc) {
      // ---
      this.setState({ arrowPrevClass: this.transitionClasses.blink, arrowNextClass: this.transitionClasses.click });
      this.delayClearArrowClass();
      let page = this.slider.page.index.pc + 1;
      // console.log('FeatureCategoryContainerHorizontal.pcNext --- continue', page, this.slider.page.last.pc);
      if (page === this.slider.page.last.pc) {
        this.pcLastWithDead(page, noMbMove, 1);
        return;
      } else if (page > this.slider.page.last.pc) {
        this.pcLastToFirst(noMbMove);
        return;
      }
      // normal
      this.slider.page.index.pc = page;
      const pcEachTime = this.slider.eachTime.pc;
      const pcExpectIndex = page * pcEachTime;
      this.pcGoto(pcExpectIndex, noMbMove);
      this.pcChangeState(page);
    }
  }

  /**
   * pc next - 最終ページで最終アイテムを右端になるように移動します
   * @param {number} page page number
   * @param {boolean} noMbMove - mb move flag
   * @param {number} [direction=1] 方向
   */
  pcLastWithDead(page, noMbMove, direction = 1) {
    const { pc } = this.slider;
    if (pc) {
      const pcEachTime = this.slider.eachTime.pc;
      const total = pcEachTime * (page + 1);
      const pcExpectIndex = page * pcEachTime;
      const rest = this.slider.length - pcExpectIndex;
      const added = total - (pcExpectIndex + rest);
      const moveTo = (pcExpectIndex - added) * direction;
      // console.log('FeatureCategoryContainerHorizontal.pcLastWithDead ||||||', moveTo, pcExpectIndex, page, total, rest, added);
      this.slider.page.index.pc = page;
      this.pcGoto(moveTo);
      this.pcChangeState(page);
    }
  }

  pcLastToFirst(noMbMove) {
    const { pc } = this.slider;
    if (pc) {
      this.slider.page.index.pc = 0;
      // console.log('FeatureCategoryContainerHorizontal.pcLastToFirst', this.slider.length, 0);
      // pc.slickGoTo(this.slider.length + 1);

      // 不具合対応
      // https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-2050
      if (this.slider.length % 4 === 0) {
        pc.slickGoTo(this.slider.length);
      } else {
        pc.slickGoTo(this.slider.length + 1);
      }

      this.slider.index.pc = 0;
      if (!noMbMove) {
        this.mbMoveByPc(0);
      }
      this.pcChangeState(0);
    }
  }

  pcGoto(index, noMbMove) {
    this.clearTimerResetSlider();
    // ---
    const { pc } = this.slider;
    if (pc) {
      pc.slickGoTo(index);
      if (!noMbMove) {
        this.mbMoveByPc(index);
      }
      this.slider.index.pc = index;
      this.slider.index.mb = index;
    }
  }

  pcMoveByMb() {
    const { pc, mb } = this.slider.page.index;
    const pcEachTime = this.slider.eachTime.pc;
    const pcExpectPage = Math.floor(mb / pcEachTime);
    // console.log('FeatureCategoryContainerHorizontal.pcMoveByMb', pcExpectPage, pc);
    if (pcExpectPage > pc) {
      this.pcNext(true);
    } else if (pcExpectPage < pc) {
      this.pcPrev(true);
    }
    this.pcChangeState(pcExpectPage);
  }

  pcChangeState(page) {
    // console.log('FeatureCategoryContainerHorizontal.pcChangeState', page, this.state.pcIndex);
    if (this.state.pcIndex !== page) {
      this.setState({ pcIndex: page });
    }
  }

  // --------------------------------------------------
  onTouchStart(event) {
    this.clearTimerResetSlider();
    this.abortOpacityZero();
    // ---
    this.resetTouchMoveVectors();
    // console.log('FeatureCategoryContainerHorizontal.onTouchStart ======', event);
    this.vectors.start.updateWithVectors(eventWithPoint(event));
  }

  onTouchEnd(event) {
    // this.clearTimerResetSlider();
    // ---
    this.vectors.end.updateWithVectors(eventWithPoint(event));
    const distanceX = this.vectors.end.distanceX(this.vectors.start);
    // swipe
    if (Math.abs(distanceX) >= this.swipeThreshold) {
      if (distanceX < 0) {
        // left
        this.mbNext();
      } else {
        // right
        this.mbPrev();
      }
    }
    this.resetTouchMoveVectors();
  }

  onTouchCancel() {
    this.resetTouchMoveVectors();
  }

  /**
   * touch move value を初期化します
   */
  resetTouchMoveVectors() {
    const { start, end } = this.vectors;
    start.reset();
    end.reset();
  }
  // ---
  onMbPrev() {
    this.mbPrev();
  }
  onMbNext() {
    this.mbNext();
  }
  mbPrev() {
    this.clearTimerResetSlider();
    // ---
    const { mb } = this.slider;
    if (mb) {
      let page = this.slider.page.index.mb - 1;
      if (page < 0) {
        page = this.slider.page.last.mb;
      }
      // console.log('FeatureCategoryContainerHorizontal.mbPrev ---', mb);
      mb.slickPrev();
      this.slider.page.index.mb = page;
      this.pcMoveByMb();
    }
  }

  mbNext() {
    this.clearTimerResetSlider();
    // ---
    const { mb } = this.slider;
    // console.log('FeatureCategoryContainerHorizontal.mbNext +++', mb);
    if (mb) {
      // setTimeout(() => {
      //   mb.slickNext();
      // }, 0);
      mb.slickNext();
      let page = this.slider.page.index.mb + 1;
      if (page > this.slider.page.last.mb) {
        page = 0;
      }
      this.slider.page.index.mb = page;
      this.pcMoveByMb();
    }
  }

  mbGoTo(index) {
    this.clearTimerResetSlider();
    // ---
    const { mb } = this.slider;
    const page = this.slider.page.index.mb;
    if (mb && page !== index) {
      setTimeout(() => {
        mb.slickGoTo(index);
      }, 0);
      this.slider.page.index.mb = index;
    }
  }

  mbMoveByPc(index) {
    const { mb } = this.slider;
    if (mb) {
      setTimeout(() => {
        mb.slickGoTo(index);
      }, 0);
      this.slider.page.index.mb = index;
    }
  }
  // --------------------------------------------------
  // syncPcThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailPc);
  //   const slider = this.slider.pc;
  //   if (this.syncCount.pc > 50 || !slider || this.slider.index.pc === this.slickIndex.pc) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.pc = this.slider.index.pc;
  //     return;
  //   }
  //   this.syncCount.pc += 1;
  //   this.timer.thumbnailPc = setTimeout(() => {
  //     this.pcGoto(0);
  //     // console.log('PickerContainer.syncPcThumbnailIndex *** timeOut', this.props.filterId, this.syncCount.pc, this.slider.index.pc, this.slickIndex.pc, Date.now());
  //     this.syncPcThumbnailIndex();
  //   }, 16);
  // }
  // syncMbThumbnailIndex() {
  //   clearTimeout(this.timer.thumbnailMb);
  //   const slider = this.slider.mb;
  //   if (this.syncCount.mb > 50 || !slider || this.slider.index.mb === this.slickIndex.mb) {
  //     // this.enableTrackTransition();
  //     this.slickIndex.mb = this.slider.index.mb;
  //     return;
  //   }
  //   this.syncCount.mb += 1;
  //   this.timer.thumbnailMb = setTimeout(() => {
  //     this.mbGoTo(0);
  //     // console.log('PickerContainer.syncMbThumbnailIndex ::: timeOut', this.props.filterId, this.syncCount.mb, this.slider.index.mb, this.slickIndex.mb, Date.now());
  //     this.syncMbThumbnailIndex();
  //   }, 16);
  // }
  // --------------------------------------------------
  resetSlider(pc) {
    const slider = pc ? this.slider.pc : this.slider.mb;
    if (slider) {
      slider.slickGoTo(0);
    }
  }
  // --------------------------------------------------
  abortOpacityZero() {
    // console.log('FeatureCategoryContainer.abortOpacityZero --------------- remove', this.props.filterId, Date.now());
    // const { abortOpacityZero } = this.props;
    // if (typeof abortOpacityZero === 'function') {
    //   abortOpacityZero.call(this);
    // }
  }
  delayAbortOpacityZeroWithTransitionZero(delay = 320) {
    this.timer.opacityZero = setTimeout(() => {
      this.abortOpacityZero();
      this.abortSlickTransitionZero();
    }, delay);
  }
  // --------------------------------------------------
  abortSlickTransitionZero() {
    const { slickThumbnailChangedCallback } = this.props;
    if (typeof slickThumbnailChangedCallback === 'function') {
      slickThumbnailChangedCallback.call(this);
    }
  }
  // --------------------------------------------------
  clearTimerResetSlider() {
    // console.log('FeatureCategoriesContainer.clearTimerResetSlider - noCountUpdate', noCountUpdate, this.timer.resetSlider);
    clearTimeout(this.timer.resetSlider);
  }
  // likeDestroySliders() {
  //   const index = this.slider.length;
  //   // console.log('FeatureCategoriesContainer.likeDestroySliders - index', index);
  //   const { pc, mb } = this.slider;
  //   if (mb) {
  //     mb.slickGoTo(index);
  //     this.slickIndex.mb = index;
  //   }
  //   if (pc) {
  //     mb.slickGoTo(index);
  //     this.slickIndex.pc = index;
  //   }
  // }

  /**
   * `react-slick` が
   */
  resetSlidersAfterDelay() {
    // console.log('FeatureCategoriesContainer.resetSlidersAfterDelay', this.props.filterId, this.props.currentFilterId, this.slider.length, this.slider.index);
    this.clearTimerResetSlider();
    // ---
    // pc
    this.resetSlider(true);
    // false
    this.resetSlider(false);
    this.slider.index.pc = 0;
    this.slider.index.mb = 0;
    if (
      this.state.length !== this.components.length ||
      this.state.pcIndex !== 0 ||
      this.state.mbIndex !== 0
    ) {
      this.setState({ length: this.components.length, pcIndex: 0, mbIndex: 0 });
    }
  }
  // // --------------------------------------------------
  // slickTrackDurationZero(duration) {
  //   if (this.state.slickTrackTransition === this.transitionClasses.slickTrackTransition) {
  //     return;
  //   }
  //   this.setState({ slickTrackTransition: this.transitionClasses.slickTrackTransition });
  //   clearTimeout(this.timer.slickTrackDuration);
  //   this.timer.slickTrackDuration = setTimeout(() => {
  //     this.setState({ slickTrackTransition: '' });
  //   }, duration);
  // }
  // --------------------------------------------------
  /**
   * index: 0, に強制的に戻す - `componentDidUpdate` 後とか...
   * - componentDidUpdate 後直ぐ slick の準備ができず, `slickGoTo(0)` が空振りするので 160ms(10fps) delay させる
   */
  resetSliders() {
    this.resetSliderCount = 0;
    // ---
    const delay = 160;
    // ---
    // this.slickTrackDurationZero(delay + 160);
    // ---
    // this.likeDestroySliders();
    // ---
    this.timer.resetSlider = setTimeout(() => {
      this.resetSlidersAfterDelay();
    }, delay);
  }

  // --------------------------------------------------
  // /**
  //  * document.body `FeatureCategoryContainer__slick-track__transition__none` add します
  //  * - transition abort します
  //  */
  // abortTrackTransition() {
  //   clearTimeout(this.timer.track);
  //   document.body.classList.add(this.trackIgnore);
  // }
  // /**
  //  * document.body `FeatureCategoryContainer__slick-track__transition__none` remove します
  //  * - transition enable します
  //  */
  // enableTrackTransition() {
  //   document.body.classList.remove(this.trackIgnore);
  // }
  // /**
  //  * {@link FeatureCategoryContainer.enableTrackTransition} 遅延実行します
  //  * @param {number} [delay=516] 遅延時間(ms)
  //  */
  // delayEnableTrackTransition(delay = 516) {
  //   clearTimeout(this.timer.track);
  //   this.timer.track = setTimeout(() => {
  //     this.enableTrackTransition();
  //     // this.abortOpacityZero();
  //   }, delay);
  // }
  // --------------------------------------------------
  /**
   * maxHeight style を削除します - orientation 時の計算のじゃまになるので
   */
  resetMaxHeight() {
    const { filterId } = this.props;
    const { pc, mb } = this.containerComponents[filterId];
    [pc, mb]
      .map(containerItems => (
        containerItems
          .filter(component => (component && component.setContainerHeight))
          .map(component => (component.setContainerHeight(null)))
      ));
    this.setState({ heightFromMaxHeight: null });
  }
  /**
   * 子供の高さを揃えるために高さを取得し max height を設定する
   * @param {string} [mode=pc] reference switch に使用します
   */
  getAndSetMaxHeight(mode = 'pc') {
    const { components, filterId } = this.props;
    const containerItems = this.containerComponents[filterId][mode];
    // slick が component 複製してしまうので original component.length で truncate する
    const cloneItems = containerItems.slice(0);

    cloneItems.length = (components || []).length;
    const results = getComponentsHeight(cloneItems);
    results.sort((a, b) => (b - a));
    const maxHeight = results[0];
    // console.log('FeatureCategoryContainerHorizontal.getAndSetMaxHeight sort', maxHeight, containerItems);
    containerItems
      .filter(component => (component && component.setContainerHeight))
      .map(component => (component.setContainerHeight(maxHeight)));
    if (mode === 'mb') {
      this.setState({ heightFromMaxHeight: maxHeight });
    }
  }
  /**
   * maxHeight 設定を遅延実行します - child component render を待ちます
   * @param {number} [delay=112] {@link FeatureCategoryContainerHorizontal.getAndSetMaxHeight} を遅延実行します
   */
  delayGetAndSetMaxHeight(delay = 112) {
    // console.log('FeatureCategoryContainerHorizontal.delayGetAndSetMaxHeight delay', delay);
    clearTimeout(this.timer.fitHeight);
    this.timer.fitHeight = setTimeout(() => {
      this.getAndSetMaxHeight();
      this.getAndSetMaxHeight('mb');
    }, delay);
    //this.resetMaxHeight();
  }
  // --------------------------------------------------
  afterMountShowSlick() {
    this.setState({ didMount: true, slickTrackTransition: '' });
  }
  // --------------------------------------------------
  clearArrowClass() {
    clearTimeout(this.timer.arrow);
    this.setState({ arrowPrevClass: '', arrowNextClass: '' });
  }
  delayClearArrowClass(delay = 1750) {
    clearTimeout(this.timer.arrow);
    this.timer.arrow = setTimeout(() => {
      this.clearArrowClass();
    }, delay);
  }
  // --------------------------------------------------
  componentDidUpdate(prevProps) {
    if (prevProps.currentFilterId !== this.props.currentFilterId) {
      this.currentFilterId = this.props.currentFilterId;
      this.clearTimerResetSlider();
      this.initSliderProps();
      // ---
      this.resetSliders();
      // ---
      // component 高さを測るために render が終わる時間待機します
      const delay = 112 * 2;
      this.delayGetAndSetMaxHeight(delay);
      // ---
      // console.log('FeatureCategoryContainerHorizontal.componentDidUpdate with clear ---------------', this.props.currentFilterId, this.props.filterId, this.slickIndex, this.props.currentFilterId === this.props.filterId && (this.slickIndex.pc === 0 || this.slickIndex.mb === 0));
      // current 表示で - index: 0 のときは slick.afterChange が fire しないので timer で起動する
      if (this.props.currentFilterId === this.props.filterId && (this.slickIndex.pc === 0 || this.slickIndex.mb === 0)) {
        this.delayAbortOpacityZeroWithTransitionZero(500);
      }
    }
  }
  componentDidMount() {
    this.delayGetAndSetMaxHeight();

    // window.addEventListener('resize', this.onResize, false);
    setTimeout(()=> {
      window.addEventListener('resize', this.onResize, false);
    }, 500);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.onResize();
    }, 1000);

    this.timer.didMount = setTimeout(() => {
      this.afterMountShowSlick();
      this.delayAbortOpacityZeroWithTransitionZero(16);
    }, 0);
  }
  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
    Object.values(this.timer).map(id => (clearTimeout(id)));
    window.removeEventListener('resize', this.onResize);
  }

  // --------------------------------------------------
  /**
   * スライド用の丸ポチが表示される
   */
  renderSliderPagerPc() {
    const { pcIndex } = this.state;
    // console.log('FeatureCategoryContainerHorizontal.renderSliderPagerPc', this.props.filterId, pcIndex, this.slider);
    const total = this.slider.page.last.pc + 1;
    const list = Array.apply(null, Array(total));
    return (
      <div className="FeatureCategoryContainer__content__pager__block">
        <div className="FeatureCategoryContainer__content__pager">
          {
            list.map((value, index) => {
              const id = `pager-${index}`;
              return (
                <button
                  key={id}
                  type="button"
                  className={`FeatureCategoryContainer__content__pager__dot ${(pcIndex === index) ? 'is-active': ''}`}
                  data-page={index}
                  onClick={this.onClickPager}
                >
                  <span/>
                </button>
              );
            })
          }
        </div>
      </div>
    );
  }

  // --------------------------------------------------
  /**
   * 各カテゴリの、スライド内の、各画像を表示する DOM 要素を返す
   */
  renderItemWrap(mode) {
    const { components, filterId } = this.props;
    // ---
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: [],
      };
    }
    if (mode === 'pc-slide') {
      this.containerComponents[filterId].pc = [];
    } else {
      this.containerComponents[filterId].mb = [];
    }
    const childRefs = (mode === 'pc-slide') ? this.containerComponents[filterId].pc : this.containerComponents[filterId].mb;
    // ---
    return (
      components.map((component, index) => {
        const props = Object.assign({}, component.props);
          switch(component.name) {
            case 'Promo': {
              return (
                <ItemPromo
                  key={`promo-${mode}-${filterId}-${index}`}
                  {...props}
                  uniqueId={`promo-${mode}-${filterId}-${index}`}
                  childRefs={childRefs}
                  inFeatureCategoriesHorizontal
                />
              );
            }
            case 'PromoAndButtonModalWindow': {
              return (
                <ItemPromoAndButtonModalWindow
                  key={`promo-${mode}-${filterId}-${index}`}
                  {...props}
                  uniqueId={`promo-${mode}-${filterId}-${index}`}
                  childRefs={childRefs}
                  inFeatureCategoriesHorizontal
                />
              );
            }
            case 'Video': {
              return (
                <ItemVideo
                  key={`promo-${mode}-${filterId}-${index}`}
                  {...props}
                  uniqueId={`promo-${mode}-${filterId}-${index}`}
                  childRefs={childRefs}
                  inFeatureCategoriesHorizontal
                />
              );
            }
            case 'Html': {
              return (
                <ItemHtml
                  uniqueId={`promo-${mode}-${filterId}-${index}`}
                  {...props}
                  key={`promo-${mode}-${filterId}-${index}`}
                  childRefs={childRefs}
                  inFeatureCategoriesHorizontal
                />
              );
            }
            case 'Wysiwyg': {
              return (
                <ItemWysiwyg
                  key={`promo-${mode}-${filterId}-${index}`}
                  {...props}
                  uniqueId={`promo-${mode}-${filterId}-${index}`}
                  childRefs={childRefs}
                  inFeatureCategoriesHorizontal
                />
              );
            }
            default: {
              return null;
            }
          }
        })
        // .filter(component => (component !== null))
    );
  }

  renderSliderPcSlick() {
    const settings = {
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 500,
      ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      ref: (component) => (this.slider.pc = component),
      // initialSlide: 0,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      className: 'feature-category_container-slick-pc',
      // ---
      fade: false,
      useTransform: false,
      // variableWidth: true,
      variableWidth: false,
      adaptiveHeight: false,
      // slidesToShow: 1,
      // slidesToScroll: 1,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      useCSS: true,
      // row: 1,
      centerMode: false,
      centerPadding: 0,
      beforeChange: this.onPcThumbnailBeforeChange,
      afterChange: this.onPcThumbnailAfterChange,
      waitForAnimate: false,
    };
    // console.log('FeatureCategoryContainerHorizontal.renderSliderPcSlick', settings);
    // console.log('ReactSlick', ReactSlick);
    return (
      <div className="FeatureCategoryContainer__content__item__wrap">
        <FeatureCategorySlider settings={settings}>
          {
            this.renderItemWrap('pc-slide')
          }
        </FeatureCategorySlider>
      </div>
    );
  }

  renderSliderPc() {
    const { components } = this.props;
    if (components.length <= 4) {
      return null;
    }
    const { arrowNextClass, arrowPrevClass } = this.state;
    return (
      <div className="FeatureCategoryContainer__content-pc">
        <div className="FeatureCategoryContainer__content__controls">
          <button
            className={`FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__prev ${arrowPrevClass}`}
            type="button"
            onClick={this.onPcPrev}
          >
            <i/>
          </button>
          <button
            className={`FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__next ${arrowNextClass}`}
            type="button"
            onClick={this.onPcNext}
          >
            <i/>
          </button>
        </div>
        {this.renderSliderPagerPc()}
        {this.renderSliderPcSlick()}
      </div>
    );
  }

  renderFlatPc() {
    const { components, filterId } = this.props;
    // const components = this.components;
    if (components.length > 4) {
      return null;
    }
    if (!this.containerComponents[filterId]) {
      this.containerComponents[filterId] = {
        pc: [],
        mb: [],
      };
    }
    this.containerComponents[filterId].pc = [];
    return (
      <div className="FeatureCategoryContainer__content-pc not__carousel-pc">
        <div className="FeatureCategoryContainer__content__item__wrap">
          <FeatureCategoryContainerItemWrap
            {...this.props}
            mode="pc-flat"
            childRefs={this.containerComponents[filterId].pc}
            inFeatureCategoriesHorizontal
          />
        </div>
      </div>
    );
  }

  renderPc() {
    const { didMount } = this.state;
    const style = didMount ? null : { overflow: 'hidden', maxHeight: '0' };
    if (style && this.contents.pc) {
      style.minHeight = `${this.contents.pc.getBoundingClientRect().height}px`;
    }
    return (
      <div
        className="FeatureCategoryContainer__content__desktop"
        style={style}
        ref={component => (this.contents.pc = component)}
      >
        {this.renderSliderPc()}
        {this.renderFlatPc()}
      </div>
    );
  }

  // --------------------------------------------------
  renderSliderMb() {
    const { components } = this.props;
    // const components = this.components;
    if (components.length <= 1) {
      return null;
    }
    // ---
    const settings = {
      arrows: false,
      autoplay: false,
      speed: 500,
      ref: (component) => (this.slider.mb = component),
      initialSlide: 0,
      swipeToSlide: false,

      // スワイプさせるようにすると、スクロールしないようにできるが、リンク（画像部分）がクリックできなくなる。
      // swipe: false,
      // touchMove: false,
      swipe: true,
      touchMove: true,

      useTransform: false,
      // ---
      // variableWidth: true,
      variableWidth: false,
      fade: false,
      // rows: 1,
      slidesPerRow: 1,
      slidesToShow: 1,
      slidesToScroll: 1,
      // centerMode: false,
      centerMode: true,
      centerPadding: 0,
      useCSS: true,
      beforeChange: this.onMbThumbnailBeforeChange,
      afterChange: this.onMbThumbnailAfterChange,
      // on　すると length 5 の挙動がおかしくなる
      // waitForAnimate: false,
    };
    return (
      <div className="FeatureCategoryContainer__content-mb">

        <div className="FeatureCategoryContainer__content__controls">
          <button
            className="FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__prev"
            type="button"
            onClick={this.onMbPrev}
          />
          <button
            className="FeatureCategoryContainer__content__btn FeatureCategoryContainer__content__next"
            type="button"
            onClick={this.onMbNext}
          />
        </div>
        <div
          className="FeatureCategoryContainer__content__item__wrap"
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
          onTouchCancel={this.onTouchCancel}
        >
          <FeatureCategorySlider settings={settings}>
            {
              this.renderItemWrap('mb-slide')
            }
          </FeatureCategorySlider>
        </div>
      </div>
    );
  }

  renderFlatMb() {
    const { components } = this.props;
    // const components = this.components;
    if (components.length > 1) {
      return null;
    }
    return (
      <div className="FeatureCategoryContainer__content-mb not__carousel-mb">
        <div className="FeatureCategoryContainer__content__item__wrap">
          <FeatureCategoryContainerItemWrap
            {...this.props}
            mode="mb-flat"
          />
        </div>
      </div>
    );
  }

  renderMb() {
    const { didMount, heightFromMaxHeight } = this.state;
    const style = (didMount) ? {} : { overflow: 'hidden', maxHeight: '0' };
    style.maxHeight = 'auto';
    // style.maxHeight = heightFromMaxHeight;
    // console.log('FeatureCategoryContainer.renderMb - didMount', style);
    return (
      <div
        className="FeatureCategoryContainer__content__mobile"
        style={style}
        ref={component => (this.contents.mb = component)}
      >
        {this.renderSliderMb()}
        {this.renderFlatMb()}
      </div>
    );
  }

  // --------------------------------------------------
  render() {
    const {
      components,
      layout,
    } = this.props;
    // ---
    if (layout !== 'Horizontal') {
      return null;
    }
    // ---
    if (!components.length) {
      return null;
    }
    const { slickTrackTransition } = this.state;
    return (
      <div className={`FeatureCategoryContainer__content FeatureCategoryContainer__content__Horizontal ${slickTrackTransition}`}>
        {this.renderPc()}
        {this.renderMb()}
      </div>
    );
  }
}

// --------------------------------------------------
/**
 *  FeatureCategoryContainer
 */
export default class FeatureCategoryContainer extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    title: PropTypes.string,
    components: PropTypes.array,
    // ---
    // extend
    showTitle: PropTypes.bool,
    currentFilterId: PropTypes.string,
    filterId: PropTypes.string,
    layout: PropTypes.string,
    pcDisplayLine: PropTypes.number,
    mbDisplayLine: PropTypes.number,
    titleClickCaller: PropTypes.func,
    // ---
    readMoreLabel: PropTypes.string,
    selectTextColor: PropTypes.string,
    filterChangeOpacityClassName: PropTypes.string,
    abortOpacityZero: PropTypes.func,
    changedFilter: PropTypes.bool,
    slickThumbnailChangedCallback: PropTypes.func,
    mobileFilter: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    title: null,
    components: null,
    // ---
    // extend
    showTitle: false,
    currentFilterId: '',
    filterId: '',
    titleClickCaller: null,
    // ---
    layout: 'Horizontal',
    pcDisplayLine: 4,
    mbDisplayLine: 4,
    // ---
    readMoreLabel: '',
    selectTextColor: 'Dark',
    filterChangeOpacityClassName: '',
    abortOpacityZero: null,
    changedFilter: false,
    slickThumbnailChangedCallback: null,
    // mobile flag
    mobileFilter: false,
  };
  static OPACITY_ZERO_CLASS_NAME = 'FeatureCategoryContainer__content__opacity_0';
  static ABORT_SLICK_TRANSITION = 'FeatureCategoryContainer__slick-track__transition__none';
  /**
   * second filter id から first filter id を生成し 親子関係を判定します
   * @param {string} filterId my filter id
   * @param {string} currentFilterId current filter id
   * @returns {boolean} true: 親子関係
   */
  static gaveCurrentFromChild(filterId, currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    const divideId = filterId.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  }
  static getDerivedStateFromPropsByMarkedId(props, state) {
    const notEmpty = props.currentFilterMarkedId !== '';
    let sameFilterId = notEmpty && props.currentFilterMarkedId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = FeatureCategoryContainer.gaveCurrentFromChild(props.filterId, props.currentFilterMarkedId);
      // console.log('FeatureCategoryContainer.getDerivedStateFromPropsByMarkedId', props.filterId, sameFilterId, props.currentFilterMarkedId, props.currentFilterId);
    }
    return {
      changeFilterId: (notEmpty && props.currentFilterMarkedId !== state.currentFilterId),
      sameFilterId,
    };
  }
  /**
   * filter id から view update 必要を判定します
   * @param {*} props React.props
   * @param {*} state React.state
   * @param {boolean} [useMarked=false] `props.currentFilterMarkedId` を使用する flag
   * @returns {{changeFilterId: boolean, sameFilterId: boolean}} change / same boolean list 返します
   */
  static getDerivedStateFromProps(props, state, useMarked = false) {
    if (useMarked) {
      return FeatureCategoryContainer.getDerivedStateFromPropsByMarkedId(props, state);
    }
    const notEmpty = props.currentFilterId !== '';
    let sameFilterId = notEmpty && props.currentFilterId === props.filterId;
    if (!sameFilterId) {
      sameFilterId = FeatureCategoryContainer.gaveCurrentFromChild(props.filterId, props.currentFilterId);
    }
    return {
      changeFilterId: (notEmpty && props.currentFilterId !== state.currentFilterId),
      sameFilterId,
    };
  }

  constructor(props) {
    super(props);
    // ---
    this.state = {
      activateCurrent: props.currentFilterId === props.filterId,
      currentFilterId: props.currentFilterId,
      currentContainerIndex: props.currentContainerIndex,
    };
    this.refTitle = null;
  }

  // --------------------------------------------------
  getTitleClientRect() {
    return (this.refTitle && this.refTitle.getTitleClientRect) ? this.refTitle.getTitleClientRect() : null;
  }
  // --------------------------------------------------
  // /**
  //  * {@link getComponents} で components を洗浄します
  //  * - getComponents - array check していないので事前にチェックする
  //  * - getComponents - null が含まれる可能性があるので filter する
  //  * - PickerContainer を除外する
  //  * @returns {Array<*>} 洗浄後の components list `PropTypes.node`
  //  */
  // convertPropsComponents() {
  //     const { components } = this.props;
  //     return Array.isArray(components) ? getComponents(components).filter(component => (component !== null)) : [];
  // }
  // --------------------------------------------------
  /**
   * 各カテゴリのコンテントを表示するための DOM要素を返す
   */
  renderWhichLayout () {
    const {
      layout,
      abortOpacityZero,
      slickThumbnailChangedCallback,
      changedFilter,
    } = this.props;
    if (layout === 'Vertical') {
      return (
        <div className="FeatureCategoryContainer__Vertical">
          <FeatureCategoryContainerVerticalPc
            {...this.props}
            abortOpacityZero={abortOpacityZero}
            slickThumbnailChangedCallback={slickThumbnailChangedCallback}
            changedFilter={changedFilter}
          />
          <FeatureCategoryContainerVerticalMb
            {...this.props}
            abortOpacityZero={abortOpacityZero}
            slickThumbnailChangedCallback={slickThumbnailChangedCallback}
            changedFilter={changedFilter}
          />
        </div>
      );
    }
    return (
      <FeatureCategoryContainerHorizontal
        {...this.props}
        abortOpacityZero={abortOpacityZero}
        slickThumbnailChangedCallback={slickThumbnailChangedCallback}
        changedFilter={changedFilter}
      />
    );
  }
  // --------------------------------------------------
  /**
   * navigation 部分の title を出力します
   * @returns {*} `FeatureCategoryContainerTitle`
   */
  renderTitle() {
    // title
    // console.log('FeatureCategoryContainer.renderTitle', this.props);
    const { sameFilterId } = FeatureCategoryContainer.getDerivedStateFromProps(this.props, this.state);
    return <FeatureCategoryContainerTitle
      {...this.props}
      sameFilterId={sameFilterId}
      ref={component => (this.refTitle = component)}
    />;
  }
  // --------------------------------------------------
  render() {
    const {
      containerId,
      containerClass,
      showTitle,
      filterId,
      currentFilterId,
      filterChangeOpacityClassName,
    } = this.props;
    // ---
    if (showTitle) {
      return this.renderTitle();
    } else if (currentFilterId !== filterId) {
      // no title - need same current filter id and filter id
      return null;
    }
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className={`FeatureCategoryContainer__transition__root ${filterChangeOpacityClassName}`}>
          <div className="FeatureCategoryContainer" data-id={filterId}>
            {
              this.renderWhichLayout()
            }
          </div>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/feature-category-container/index.jsx